import React, { useMemo } from "react";
import { ColDef, IAggFuncParams, ValueFormatterParams } from "@ag-grid-community/core";

import { Schedules, SchedulesData } from "fond/types";
import { numberPercentValueFormatter } from "fond/widgets/AgGrid";

import { VisualizationTypes } from "../VisualizationTypes";

import RevenueData from "./RevenueData";
import { addressTypeTransformer } from "./transforms";

interface IProps {
  data?: SchedulesData[Schedules.Hhc];
}

const HHCSchedule: React.FC<IProps> = ({ data }) => {
  const addressTypes: string[] = useMemo(() => [...new Set<string>(data?.map(({ AddressType }) => AddressType))], [data]);
  const phases: string[] = useMemo(() => [...new Set<string>(data?.map(({ Phase }) => Phase))], [data]);
  const pivotData = useMemo(
    () => addressTypeTransformer<SchedulesData[Schedules.Hhc]>(Schedules.Hhc, addressTypes, phases, data),
    [addressTypes, data, phases]
  );

  const columns: ColDef[] = useMemo(
    () => [
      {
        field: "AddressType",
        headerName: "AddressType",
        rowGroup: true,
        width: 200,
        minWidth: 200,
        hide: true,
      },
      ...(phases?.map((phase) => ({
        aggFunc: (params: IAggFuncParams) => {
          return params.values[2]; // Index 2 = Cumulative percent
        },
        field: phase,
        minWidth: 125,
        width: 125,
        valueFormatter: (params: ValueFormatterParams) => {
          // Undefined is the group level cell data where we also display the Cumulative percent
          if (params.data === undefined || params.data.Key === "Cumulative percent") return numberPercentValueFormatter(params);
          return params.value;
        },
      })) || []),
    ],
    [phases]
  );

  return <RevenueData columns={columns} gridOptions={VisualizationTypes.Hhc.gridOptions} rowData={pivotData} />;
};

export default HHCSchedule;
